module.exports = __webpack_public_path__ + "img/艾叶.6cd2400a.jpg";